import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { AddOnService } from 'src/app/services/add-on.service';
import { PartnerService } from 'src/app/services/partner.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  standalone: false,
  selector: 'app-add-ons-list',
  templateUrl: './add-ons-list.component.html',
})
export class AddOnsListComponent implements OnInit {
  items: any[] = [];
  partners: any[] = [];
  products: any[] = [];
  paginationConfig: PaginationInstance = {
    id: 'add_ons_listing',
    itemsPerPage: 10,
    totalItems: 0,
    currentPage: 1,
  };

  constructor(
    private addOnService: AddOnService,
    private partnerService: PartnerService,
    private productService: ProductService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.partnerService.list().subscribe({
      next: (partners) => {
        this.partners = partners;
        this.cdr.detectChanges();
      },
      error: () => this.toaster.error('Failed to load partners.'),
    });
    this.productService.list({ page: 1, per_page: 100 }).subscribe({
      next: (result) => {
        this.products = result?.data?.products ?? [];
        this.cdr.detectChanges();
      },
      error: () => this.toaster.error('Failed to load products.'),
    });
    this.loadItems();
  }

  loadItems(): void {
    this.addOnService.list().subscribe({
      next: (result) => {
        this.items = result?.data?.add_ons ?? [];
        this.paginationConfig.totalItems = this.items.length;
        this.clampPage();
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to load add-ons.');
      },
    });
  }

  onPageChange(page: number): void {
    this.paginationConfig.currentPage = page;
  }

  partnerName(partnerId: string | null | undefined): string {
    if (!partnerId) {
      return '-';
    }
    const match = this.partners.find((p) => String(p.partner_id) === String(partnerId));
    return match?.name ?? String(partnerId);
  }

  productName(productId: number | string | null | undefined): string {
    if (productId === null || productId === undefined || productId === '') {
      return '-';
    }
    const match = this.products.find((p) => String(p.id) === String(productId));
    return match?.name ?? String(productId);
  }

  discountTypeLabel(type: number): string {
    return type === 1 ? 'Amount' : type === 2 ? 'Percentage' : String(type ?? '-');
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }

  private clampPage(): void {
    const perPage = this.paginationConfig.itemsPerPage || 10;
    const maxPage = Math.max(1, Math.ceil((this.paginationConfig.totalItems ?? 0) / perPage));
    const current = this.paginationConfig.currentPage ?? 1;
    this.paginationConfig.currentPage = Math.min(Math.max(1, current), maxPage);
  }
}
